import { GameContext } from '../../../contexts/GameContext';
import { ImageWrapper } from '../../../components/common/wrappers/ImageWrapper';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { ZdarKidsGameStepConfiguration } from '../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import { isEmptyObject } from '../../../util/isEmptyObject';
import Loading from '../../../components/common/Loading';
import React, { useContext } from 'react';
import ZdarKidsHeader from '../../../components/games/zdar-kids-game/ZdarKidsHeader';
import ZdarKidsTaskText from '../../../components/games/zdar-kids-game/ZdarKidsTaskText';
import ZdarKidsTaskTitle from '../../../components/games/zdar-kids-game/ZdarKidsTaskTitle';
import facebook from '../../../assets/icons/facebook.svg';
import instagram from '../../../assets/icons/instagram.svg';
import logo from '../../../assets/images/common/logo.webp';
import website from '../../../assets/icons/website.svg';

type Props = {
    title?: string;
    currentStep: number;
};

export default function ZdarKidsEnding(props: Props) {
    const { availableGame } = useContext(ProfileContext);
    const { stepContent } = useContext(GameContext);
    const { taskText } = stepContent as ZdarKidsGameStepConfiguration;

    const countPoints = () => {
        let count = 0;
        if (availableGame?.stats) {
            Object.values(availableGame?.stats).forEach((value) => {
                // @ts-expect-error
                if (value.points) {
                    // @ts-expect-error
                    count += value.points;
                }
            });
        }
        return count;
    };
    const getPoints = () => {
        const count = countPoints();
        return (
            <div className="zdar-ending-time-wrapper">
                <div className="zdar-ending-time-part bigger">{count}</div>
            </div>
        );
    };

    const getPointsText = () => {
        const count = countPoints();
        let text = '';
        if (count >= 100) {
            text =
                'Jsi hotový detektiv! Kam se na tebe hrabe Sherlock Holmes. Je vidět, že máš na řešení záhad nadání, nechceš si otevřít detektivní kancelář?';
        } else if (count >= 70) {
            text =
                'Skvělá práce, sice ti pár úkolů uniklo, ale i tak si všechno splnil/a na výbornou. Míša měl velké štěstí, že jsi mu pomáhal/a právě ty.';
        } else if (count >= 30) {
            text =
                'Je vidět, že ještě na některých svých detektivních schopnostech musíš zapracovat, ale jsi rozhodně na dobré cestě!';
        } else {
            text =
                'Jéé, tady dneska někdo neměl svůj den. Snad sis hru ale alespoň užil/a  na maximum, to je přece to hlavní.';
        }
        return text;
    };

    const renderSocial = () => {
        return (
            <div className="zdar-social__wrapper">
                <div className="zdar-social__text">Více o dalších dobrodružstvích od Šifrovky naleznete zde:</div>
                <div className="zdar-social__icons">
                    <a href="https://www.facebook.com/sifrovka'" target="_blank" rel="noreferrer">
                        <div className="social-icon__wrapper social-icon__wrapper--facebook">
                            <img src={facebook} alt="facebook" width={50} height={50} />
                        </div>
                    </a>
                    <a href="https://www.instagram.com/sifrovka/" target="_blank" rel="noreferrer">
                        <div className="social-icon__wrapper social-icon__wrapper--instagram">
                            <img src={instagram} alt="instagram" width={46} height={46} />
                        </div>
                    </a>
                    <a href="https://sifrovka.cz/" target="_blank" rel="noreferrer">
                        <div className="social-icon__wrapper social-icon__wrapper--website">
                            <img src={website} alt="website" width={26} height={26} />
                        </div>
                    </a>
                </div>
            </div>
        );
    };

    if (isEmptyObject(stepContent)) {
        return (
            <React.Fragment>
                <div className="zdar-kids-game">
                    <div className="zdar-kids-game-wrapper">
                        <ZdarKidsHeader />
                        <div className="card game-card">
                            <Loading color="#23ab70" />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    if (availableGame) {
        const lastStep = availableGame.lastStep;
        if (lastStep === null || (lastStep && props.currentStep < lastStep)) {
            return (
                <React.Fragment>
                    <div className="zdar-kids-game">
                        <div className="zdar-kids-game-wrapper">
                            <ZdarKidsHeader />
                            <div className="card game-card">
                                <Loading color="#23ab70" />
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    return (
        <div className="card game-card">
            {props.title && <ZdarKidsTaskTitle text={props.title} />}
            {taskText && <ZdarKidsTaskText text={taskText} />}
            <div className="zdar-ending-score zdar-ending-score__first">
                <div className={props.title ? 'task-text' : 'task-text task-text--standalone'}>
                    <div className="zdar-ending-time-title">Získané mince:</div>
                    {getPoints()}
                </div>
            </div>
            <div className="zdar-ending-score zdar-ending-score__subtext zdar-ending-score__last">
                <div className={props.title ? 'task-text' : 'task-text task-text--standalone'}>{getPointsText()}</div>
            </div>
            {renderSocial()}
            <div className="zdar-ending-logo">
                <a href="https://sifrovka.cz/" target="_blank" rel="noreferrer">
                    <ImageWrapper src={logo} alt="logo" />
                </a>
            </div>
        </div>
    );
}
